export default __webpack_public_path__ + "static/single-leave-01-7346e5138aa45b60249c2053255788b4.png";